import { useLocation } from "react-router-dom";

export type Lang = "pt" | "en";

export const LANGS: Lang[] = ["pt", "en"];

/** Language implied by a pathname. `/en` or `/en/...` => en, otherwise pt. */
export function langFromPath(pathname: string): Lang {
  return pathname === "/en" || pathname.startsWith("/en/") ? "en" : "pt";
}

/**
 * Path for the same page in the target language.
 * Strips a leading `/en` segment, then re-adds it when targeting en, so
 * `/terms` <-> `/en/terms` and `/privacy` <-> `/en/privacy` stay in sync.
 */
export function localizePath(pathname: string, lang: Lang): string {
  const base = pathname.replace(/^\/en(?=\/|$)/, "") || "/";
  if (lang === "pt") return base;
  return base === "/" ? "/en" : "/en" + base;
}

/** Preferred language from the browser. Anything non-Portuguese => en. */
export function detectBrowserLang(): Lang {
  const nav =
    typeof navigator !== "undefined" ? navigator.language || "" : "";
  return nav.toLowerCase().startsWith("pt") ? "pt" : "en";
}

/** Current language, derived from the router location (URL is the source of truth). */
export function useLang(): Lang {
  return langFromPath(useLocation().pathname);
}
